export const TENANT_REGIONS = {
  '0h73903ce73h41d4a7165e8429j19870': 'dxb',
  'f47ac10b58cc4372a5670e029j198745': 'ksa'
}